'use client';
import { TenantProvider } from './tenant/TenantProvider';
import { PropsWithChildren } from 'react';
import { MuiProvider } from './mui';
import { TenantConfig } from '@jd/client/tenant/getSiteConfig';

type Props = {
  fontRegistry: Record<string, string>;
  tenantConfig: TenantConfig;
  allLocales: string[];
  inPayload?: boolean;
};

const defaultTheme = {
  palette: {},
  shape: { borderRadius: 4 },
  fonts: { default: 'inter' },
};

const UiProviders = ({
  fontRegistry,
  tenantConfig,
  allLocales,
  children,
  inPayload,
}: PropsWithChildren<Props>) => {
  return (
    <>
      <MuiProvider
        themeConfig={tenantConfig.theme || defaultTheme}
        fontRegistry={fontRegistry}
        inPayload={inPayload}
      >
        <TenantProvider tenantConfig={tenantConfig} allLocales={allLocales}>
          {children}
        </TenantProvider>
      </MuiProvider>
    </>
  );
};
export default UiProviders;
